  export const toTestId = (value) => 
    value
      .toLowerCase()
      .normalize("NFD") // separa o acento da letra
      .replace(/[\u0300-\u036f]/g, "") // remove resto dos acentos
      .replace(/\s+/g, "-")            
      .replace(/[^a-z0-9-]/g, "");     // remove símbolos  